var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-gallery"},[_c('gallery',{attrs:{"images":_vm.fullSizeImages,"index":_vm.index},on:{"close":function($event){_vm.index = null}}}),_vm._v(" "),_vm._l((_vm.images),function(image,imageIndex){return _c('div',{key:imageIndex,staticClass:"image cursor-pointer",class:['img-'+imageIndex],style:({ backgroundImage: 'url(' + image.thumbnail + ')'}),on:{"click":function($event){_vm.index = imageIndex}}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74468b00","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/homepage/Gallery.vue
// module id = 43
// module chunks = 0